import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $failure, $requesting, $success } from "../form/action";
import { $processing, $done } from "services/activity/action";

export const MODULE = "Leg";

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $get = ActionCreator.Async(
  MODULE,
  "Get",
  (manifest_id, payload) => {
    return async (dispatch) => {
      dispatch($processing($get.OPERATION));

      return await Rest.GET(
        `${API_URL}/tms/manifest/${manifest_id}/leg`,
        payload
      )
        .then((response) => {
          dispatch($get.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return error;
        })
        .finally(() => dispatch($done($get.OPERATION)));
    };
  }
);

export const $show = ActionCreator.Async(
  MODULE,
  "Show",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($processing($show.OPERATION));

      return await Rest.GET(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}`,
        payload
      )
        .then((response) => {
          dispatch($show.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return error;
        })
        .finally(() => dispatch($done($show.OPERATION)));
    };
  }
);

export const $arrival = ActionCreator.Async(
  MODULE,
  "Arrival",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/arrival`,
        payload
      )
        .then((response) => {
          dispatch($arrival.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return error;
        });
    };
  }
);

export const $loading = ActionCreator.Async(
  MODULE,
  "Loading",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/loading`,
        payload
      )
        .then((response) => {
          dispatch($loading.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return error;
        });
    };
  }
);

export const $departure = ActionCreator.Async(
  MODULE,
  "Departure",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/depature`,
        payload
      )
        .then((response) => {
          dispatch($departure.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return error;
        });
    };
  }
);

export const $delivered = ActionCreator.Async(
  MODULE,
  "Delivered",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/delivered`,
        payload
      )
        .then((response) => {
          dispatch($delivered.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return error;
        });
    };
  }
);

export const $disputed = ActionCreator.Async(
  MODULE,
  "Disputed",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/dispute`,
        payload
      )
        .then((response) => {
          dispatch($disputed.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return error;
        });
    };
  }
);

export const $collected = ActionCreator.Async(
  MODULE,
  "Collected",
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/collected`,
        payload
      )
        .then((response) => {
          dispatch($collected.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return error;
        });
    };
  }
);